import { useEffect, useState } from "react";
import { PortData, getPort } from "../remote/scan_data"
import { Button, CircularProgress, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";

export interface PortProps {
	id: string
	data?: PortData | undefined
	hideChildren?: boolean
}

export const PortSimple = ({id, data=undefined}: PortProps) => {
	const navigate = useNavigate()

	const [portData, setPortData] = useState<PortData | null | undefined>(data);
	useEffect(() => {
		if (data == undefined) {
			getPort(id, (data, resp) => {
				if (data) {
					setPortData(data);
				} else {
					setPortData(null);
				}
			});
		}
	}, [setPortData]);

	return (portData
		? <Button onClick={() => navigate(`/tree/port/${id}`)}>
			<Typography variant="body1" fontWeight={700} marginRight='1em'>Port</Typography>{portData.port}
		</Button>
		: <CircularProgress />
	)
}

export const Port = ({id, data=undefined, hideChildren=false}: PortProps) => {
	const navigate = useNavigate()

	const [portData, setPortData] = useState<PortData | null | undefined>(data);
	useEffect(() => {
		if (data == undefined) {
			getPort(id, (data, resp) => {
				if (data) {
					setPortData(data);
				} else {
					setPortData(null);
				}
			});
		}
	}, [setPortData]);

	return (portData
		? <TableContainer component={Paper}>
			<Table width={hideChildren ? 'auto' : '100%'}>
				<TableHead>
					<TableRow>
						<TableCell>
							<Typography variant="h5">Port</Typography>
						</TableCell>
						<TableCell align='right'>
							{hideChildren ? (<></>) :
							(portData.children.length > 0 ?
							<Button onClick={() => navigate(`/tree/port/${id}`)}>See children</Button>
							: <Button disabled>No children</Button>)}
						</TableCell>
					</TableRow>
				</TableHead>
				<TableBody>
				<TableRow><TableCell align='left'>Port</TableCell><TableCell align='right'>{portData.port}</TableCell></TableRow>
				<TableRow><TableCell align='left'>First seen</TableCell><TableCell align='right'>{String(portData.first_seen)}</TableCell></TableRow>
				<TableRow><TableCell align='left'>Last seen</TableCell><TableCell align='right'>{String(portData.last_seen)}</TableCell></TableRow>
				</TableBody>
			</Table>
		</TableContainer>
		: <CircularProgress />
	)
}
